
import Vue, { PropType } from "vue";
import { DcmFormMetadata } from "../interfaces/DcmListActions";
import { DcmService, FileService } from "../services";
import { FileRepresentation } from "../interfaces/DcmDocumentListConfiguration";

export default Vue.extend({
  props: {
    path: String,
    title: String,
    dcmName: Boolean,
    formMetadatas: Array as PropType<DcmFormMetadata[] | undefined>,
    staticMetadatas: Object as PropType<{ [key: string]: any } | undefined>,
  },
  data() {
    return {
      files: [] as File[],
      // deep copy formMetadatas to avoid referencing
      formFields: this.formMetadatas ? this.formMetadatas.map(field => ({ ...field })) : undefined,
    };
  },
  computed: {
    isValid: function() {
      if (this.files.length == 0) {
        return false;
      }
      if (this.formFields) {
        for (const field of this.formFields) {
          if (field.required && !field.value) {
            return false;
          }
        }
      }
      return true;
    },
  },
  methods: {
    async submit() {
      for (const file of this.files) {
        await this.createDocument(file);
      }
      this.$modal.close(true);
    },
    async createDocument(file: File) {
      const metadata: { [key: string]: any } = {};
      if (this.staticMetadatas) {
        Object.assign(metadata, this.staticMetadatas);
      }
      if (this.formFields) {
        for (const field of this.formFields) {
          if (field.value) {
            metadata[field.key] = field.value;
          }
        }
      }
      /*
      const fileRepresentation: FileRepresentation = await FileService.convertToFileRepresentation(
        file,
        file.name,
        metadata
      );

      await DcmService.createDocument(fileRepresentation, this.path);*/
      await DcmService.createDocument(file, metadata, this.path);
    },
  },
});
